import React, { FC, ReactNode } from "react";

import { Button } from "@/components/atoms/buttons/Button";
import { BasicModal } from "@/components/atoms/modals/BasicModal";
import { ModalFoot } from "@/components/molecules/modals/Modal";

interface Props {
  isOpen: boolean;
  close: () => void;
  submit: () => void;
  title: string;
  btnText: string;
  cancelable?: boolean;
  cancel?: () => void;
  cancelLabel?: string;
  children: ReactNode;
  showCloseIcon?: boolean;
  submitDisabled?: boolean;
}

export const CommonModal: FC<Props> = ({
  isOpen,
  close,
  submit,
  title,
  btnText,
  cancelable,
  cancel,
  cancelLabel,
  children,
  showCloseIcon = true,
  submitDisabled,
}) => {
  return (
    <>
      <BasicModal
        isOpen={isOpen}
        close={close}
        title={title}
        showCloseIcon={showCloseIcon}
      >
        <div className="p-4">{children}</div>
        {((cancelable && cancel) || !!btnText) && (
          <ModalFoot className="space-x-4">
            {cancelable && cancel && (
              <Button
                type="button"
                size="sm"
                color="cancel"
                onClick={cancel}
                label={cancelLabel ? cancelLabel : "キャンセル"}
              ></Button>
            )}
            {!!btnText && (
              <Button
                type="submit"
                size="sm"
                color="primary"
                label={btnText}
                disabled={submitDisabled}
                onClick={() => submit()}
              />
            )}
          </ModalFoot>
        )}
      </BasicModal>
    </>
  );
};
